import { NgModule } from '@angular/core';
import { AnimatedGradientTextComponent } from './animated-gradient-text.component';

@NgModule({
    declarations: [
        AnimatedGradientTextComponent
    ],
    imports: [],
    exports: [
        AnimatedGradientTextComponent
    ]
})
export class NcAnimatedGradientTextModule { }